<template>
  <div class="flex flex_col procudtion-page">
    <!-- 上面的选择 -->
    <div class="selects">
      <el-form
        :model="queryParam"
        ref="ruleform"
        :inline="true"
        class="flex flex_ju_sb warnform-inline"
      >
        <div class="form-inputs">
          <el-form-item label="选择农事类型">
            <el-select
              placeholder="请选择"
              v-model="queryParam.typeId"
              clearable
            >
              <el-option
                v-for="(item, index) in orgSelect"
                :key="index"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择时间" class="form-picker">
            <div class="picker-divs">
              <el-date-picker
                v-model="queryParam.startTime"
                size="small"
                type="date"
                placeholder="选择日期"
                popper-class="pick-poper"
                class="picker-div"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                prefix-icon=" "
                clear-icon="el-icon-date"
                :clearable="false"
                :picker-options="pickerOptions0"
              >
              </el-date-picker>
              <i class="pick-icon el-icon-date"></i>
            </div>

            <span class="pick-word">至</span>
            <div class="picker-divs">
              <el-date-picker
                v-model="queryParam.endTime"
                size="small"
                type="date"
                placeholder="选择日期"
                popper-class="pick-poper"
                class="picker-div"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                prefix-icon=" "
                clear-icon="el-icon-date"
                :clearable="false"
                :picker-options="pickerOptions1"
              >
              </el-date-picker>
              <i class="pick-icon el-icon-date"></i>
            </div>
          </el-form-item>
        </div>

        <el-form-item class="form-btns">
          <el-button type="primary" @click="searchClick">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 下面的表格 -->
    <div class="flex flex_col warn-tables" v-loading="loading">
      <!-- 新增按钮 -->
      <div class="cursor flex flex_a_c flex_ju_c btn-add" @click="handleAdd">
        <img class="icon_add" src="@/assets/image/icon_add.png" alt="" />
        <span class="font_14 c_white btn-word">新增</span>
      </div>
      <el-table
        :data="tableData"
        class="tables"
        :height="535"
        :stripe="true"
        align="center"
        header-cell-class-name="header-cell"
        cell-class-name="table-cell"
      >
        <el-table-column type="index" label="序号" width="100" align="center">
        </el-table-column>
        <el-table-column
          prop="orgName"
          label="生产区域"
          width="180"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="bioName"
          label="作物名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="typeName"
          label="农事类型"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="content"
          label="农事详情"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.content"
              placement="top"
              popper-class="tableTooltip"
            >
              <span>{{ scope.row.content | length }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="操作时间"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="userName"
          label="创建人"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span class="table-edit" @click="handleEdit(scope.row)">编辑</span>
            <span class="table-del" @click="handleDel(scope.row)">删除</span>
          </template>
        </el-table-column>
        <!-- 占位数据 -->
        <div slot="empty" class="table-empty">
          <img
            class="table-noimg"
            src="@/assets/image/home/img_none.png"
            alt=""
          />
          <div class="table-emptyword">暂无数据</div>
        </div>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        class="pagination"
        layout="prev, pager, next"
        :current-page.sync="ipagination.currentPage"
        :page-size="ipagination.pageSize"
        :total="ipagination.total"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <!-- 新增和编辑弹窗 -->
    <production-table-modal
      ref="modalForm"
      @updataList="loadData"
    ></production-table-modal>
  </div>
</template>

<script>
import ProductionTableModal from "./modules/ProductionTableModal.vue";
/**
 * @description 首页子页面设备总数
 */
import tableMinin from "@/mixins/TableMinin";
export default {
  mixins: [tableMinin],
  components: { ProductionTableModal },
  data() {
    const self = this;
    return {
      isFillTime: true,
      isTranPage: true,
      ifUseLoadBack: false,
      orgSelects: [], // 区域下拉选数据
      orgSelect: [], // 头部下拉选数据
      url: {
        list: self.$api.proTableList,
      },
      tableData: [],
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.queryParam.endTime) {
            if (this.queryParam.endTime != "") {
              let num = new Date(this.queryParam.endTime).getTime();
              return time.getTime() > num;
            } else {
            }
          } else {
            return false;
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          let num = new Date().getTime();
          if (time.getTime() > num) {
            return true;
          } else {
            let startNum =
              new Date(this.queryParam.startTime).getTime() - 43200000;
            if (time.getTime() < startNum) {
              return true;
            } else {
              return false;
            }
          }
        },
      },
    };
  },
  mounted() {
    // 获取农事类型
    this.getTypeSelect();
    // TODO
    let userInfo = JSON.parse(window.localStorage.getItem("wlwUserInfo"));
    this.queryParam.orgId = userInfo["orgId"];
    this.$nextTick(() => {
      // 请求表格数据
      this.loadData(1);
    });
  },
  filters: {
    length(value) {
      let str = "";
      if (value) {
        if (value.length >= 13) {
          str = value.slice(0, 13) + "...";
        } else {
          str = value;
        }
        return str;
      } else {
        return "---";
      }
    },
  },
  methods: {
    // // 获取区域下拉选数据
    // getOrgCode() {
    // 	let params = {
    // 		orgId: '',
    // 	}
    // 	this.$http
    // 		.getAction(this.$api.findFarmingByOrgCode, params)
    // 		.then((res) => {
    // 			console.log('llllll')
    // 			if (res.meta.success) {
    // 				let datas = res.data || []
    // 				this.orgSelects = datas || []
    // 			} else {
    // 				this.orgSelects = []
    // 			}
    // 		})
    // 		.catch(() => {
    // 			this.orgSelects = []
    // 		})
    // },
    // 获取农事类型
    getTypeSelect() {
      this.$http.getAction(this.$api.proFindTypeByOrgId).then((res) => {
        if (res.meta.success) {
          let datas = res.data || [];
          this.orgSelect = datas || [];
        } else {
          this.orgSelect = [];
        }
      });
    },
    loadBack(res) {
      if (res.meta.success) {
        let result = res.data || {};
        if (result.total > 0) {
          let datas = result.records || [];
          this.tableData = datas || [];
          this.ipagination.total = Number(result.total);
          this.ipagination.pageSize = Number(result.size);
        } else {
          this.tableData = [];
          this.ipagination.total = 0;
          this.ipagination.pageSize = 10;
        }
      } else {
        this.tableData = [];
        this.ipagination.total = 0;
        this.ipagination.pageSize = 10;
      }
    },
    // 新增按钮点击
    handleAdd() {
      this.$refs.modalForm.set(this.orgSelect);
      this.$refs.modalForm.add();
      this.$refs.modalForm.titles = "新增农事";
    },
    // 编辑按钮点击
    handleEdit(rows) {
      this.$refs.modalForm.set(this.orgSelect);
      this.$refs.modalForm.edit(rows);
      this.$refs.modalForm.titles = "编辑农事";
    },
    // 删除按钮点击
    handleDel(rows) {
      console.log(rows);
      this.$confirm("确定删除信息吗？", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "del-dialog",
        cancelButtonClass: "btn-cancel",
        confirmButtonClass: "btn-confirm",
      })
        .then(() => {
          this.deleteData(rows);
        })
        .catch(() => {
          // this.$message('已取消删除', 'info')
        });
    },
    async deleteData({ id }) {
      let params = {
        id: id,
      };
      await this.$http
        .getAction(this.$api.productionDelete, params)
        .then((res) => {
          if (res.meta.success) {
            this.loadData(1);
            this.$message("删除成功", "success");
          } else {
            this.$message("操作失败，请稍后重试", "error");
          }
        })
        .catch(() => {
          this.$message("操作失败，请稍后重试", "error");
        });
      // // TODO 请求删除接口
      // const newData = this.tableData.filter((item) => item.id !== rows.id)
      // this.tableData = newData
      // this.$message('删除成功', 'success')
    },
  },
};
</script>

<style lang="scss" scoped>
.procudtion-page {
  height: 100%;
  .warn-tables {
    padding-top: 0.25rem;
    padding-bottom: 0.15rem;

    flex: 1;
    min-height: 610px;
    .tables {
      // 单元格
      .table-cell {
        color: #666666;
        font-size: 0.17rem;
      }
    }
  }
  // 新增按钮
  .btn-add {
    text-align: center;
    width: 1rem;
    height: 0.45rem;
    line-height: 0.45rem;
    background: #2daea9;
    border-radius: 0.04rem;
    margin: 0 0 0.25rem 0.5rem;
    .icon_add {
      width: 0.2rem;
    }
    .btn-word {
      margin-left: 0.1rem;
    }
  }
  // 表格中的样式
  .tables {
    .table-edit {
      font-size: 0.17rem;
      color: #2daea9;
      cursor: pointer;
    }
    .table-del {
      font-size: 0.17rem;
      color: #e33434;
      margin-left: 0.3rem;
      cursor: pointer;
    }
  }
  .pagination {
    padding-top: 0;
  }
}
</style>
<style>
.tableTooltip {
  max-width: 6.25rem;
  background: #ffffff !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  box-shadow: 0px 0px 21px 0px rgba(45, 174, 169, 0.35);
  opacity: 0.92;
  color: #666666 !important;
}
.tableTooltip .popper__arrow,
.tableTooltip .popper__arrow::after {
  border-top-color: #ffffff !important;
}
</style>
<style lang="scss" scoped>
@import "@/assets/css/del_dialog.scss";
</style>
